import { render, staticRenderFns } from "./WPCartComponent.vue?vue&type=template&id=45d1a82e&"
import script from "./WPCartComponent.vue?vue&type=script&lang=js&"
export * from "./WPCartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports